import React from 'react'

import {CircleStroke} from '@/components/common/progress/CircleStroke'
import {theme} from '@/theme/theme'

import {Text, TextVariant} from '../content/Text'

type PercentageCircleProps = {
  percentage: string | number
}

export const PercentageCircle: React.FC<React.PropsWithChildren<PercentageCircleProps>> = ({
  percentage,
}) => {
  const PERCENTAGE_CIRCLE_SIZE_LARGE = '120px'

  return (
    <>
      <div className="wrapper">
        <CircleStroke percentage={percentage} circleColor={theme.palette.secondary.main} />
        <Text variant={TextVariant.h3} element="p" align="center">
          <span className="percentage">{percentage}</span>
        </Text>
      </div>

      <style jsx>{`
        .wrapper {
          position: relative;
          width: ${PERCENTAGE_CIRCLE_SIZE_LARGE};
          height: ${PERCENTAGE_CIRCLE_SIZE_LARGE};
          flex: 0 0 ${PERCENTAGE_CIRCLE_SIZE_LARGE};
          margin: 0 auto;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .percentage {
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
        .percentage:after {
          content: '%';
          position: absolute;
          margin-top: -${theme.spacing[1]};
          ${theme.typography.text14.desktop};
          color: ${theme.palette.text.primary};
        }
      `}</style>
    </>
  )
}
